var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Cube"},[_c('div',{staticClass:"tabs"},[_c('ul',[_c('router-link',{attrs:{"to":{ name: 'Mapper' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var isActive = ref.isActive;
return [_c('li',{class:{ 'is-active': isActive }},[_c('a',{attrs:{"href":href}},[_vm._v("Mapper")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'Designer' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var isActive = ref.isActive;
return [_c('li',{class:{ 'is-active': isActive }},[_c('a',{attrs:{"href":href}},[_vm._v("Designer")])])]}}])}),_c('router-link',{attrs:{"to":{ name: 'Job' }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var isActive = ref.isActive;
return [_c('li',{class:{ 'is-active': isActive }},[_c('a',{attrs:{"href":href}},[_vm._v("Pipeline")])])]}}])})],1)]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }